import { render, staticRenderFns } from "./profileChildComponentViewer.vue?vue&type=template&id=0b440fec&scoped=true&"
import script from "./profileChildComponentViewer.vue?vue&type=script&lang=ts&"
export * from "./profileChildComponentViewer.vue?vue&type=script&lang=ts&"
import style0 from "./profileChildComponentViewer.vue?vue&type=style&index=0&id=0b440fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b440fec",
  null
  
)

export default component.exports